module.exports = __webpack_public_path__ + "static/img/bg.5d45b919.webp";